import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://assetwisebusiness.com';
const OG_IMAGE = 'https://static.prod-images.emergentagent.com/jobs/4085bf83-1b67-4600-9400-162cbac32cc2/images/7a285d20fbaf20c9b2e8c22c74aa7a2b86d8fe285805663aacda57e00894c90d.jpeg';

export const SEO = ({ title, description, path = '/', keywords, noIndex = false }) => {
  const url = `${SITE_URL}${path}`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="AssetWise Business Consultants" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={OG_IMAGE} />
      <meta property="og:locale" content="en_IN" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={OG_IMAGE} />
    </Helmet>
  );
};

export default SEO;
